<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Class Course
                        </th>
                        <th class="text-center">
                            Once / Permanent
                        </th>
                        <th class="text-left">
                            From
                        </th>
                        <th class="text-left">
                            To
                        </th>
                        <th class="text-left">
                            Reason
                        </th>
                        <th>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="request in requests" :key="request.id">
                        <td class="py-3">
                            <div class="d-flex align-center">
                                <router-link class="me-3" :to="{name: 'course', params: {id: request.enrollment.course.id}}">
                                    <v-avatar tile width="60" height="50" style="border-radius: 5px!important" v-ripple="{class: 'black--text'}">
                                        <v-img :src="request.enrollment.course.image_url" />
                                    </v-avatar>
                                </router-link>
                                <div>
                                    <div class="strong-text--text nowrap mb-1 font-weight-medium">{{request.enrollment.course.name}}</div>
                                    <div>
                                        <v-chip class="font-weight-medium" text small label>
                                            Waiting on: {{otherPartyName(request)}}
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <v-chip v-if="request.permanent" color="primary">
                                <v-icon size="20" left class="me-1">mdi-repeat</v-icon>
                                Permanent
                            </v-chip>
                            <v-chip v-else>
                                <v-icon size="20" left class="me-1">mdi-numeric-1-circle-outline</v-icon>
                                Once
                            </v-chip>
                        </td>
                        <td>
                            <v-chip text class="font-weight-medium">
                                <v-icon left>mdi-clock-outline</v-icon>
                                <span>{{request.old_start_formated}}</span>
                            </v-chip>
                        </td>
                        <td>
                            <v-chip color="teal" text class="teal lighten-5 teal--text text--darken-2 font-weight-bold">
                                <v-icon left>mdi-clock-outline</v-icon>
                                <span>{{request.start_formated}}</span>
                            </v-chip>
                        </td>
                        <td>
                            <v-btn v-if="request.reason" @click="openReasonDialog(request)">
                                <v-icon left>mdi-text</v-icon>
                                <span style="text-transform: none">Show Reason</span>
                            </v-btn>
                            <span v-else>No Reason</span>
                        </td>
                        <td style="white-space: nowrap;">
                            <v-btn color="indigo" dark class="me-2" @click="showEditDialog(request)">
                                <v-icon left size="18">mdi-pencil</v-icon>
                                Edit
                            </v-btn>
                            <v-btn v-if="isOriginalSender(request)" color="red" dark @click="showCancelDialog(request)">
                                <v-icon left size="18">mdi-close-circle-outline</v-icon>
                                Cancel
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <!-- Reason Dialog -->
        <v-dialog v-model="reasonDialog" max-width="350">
            <v-card>
                <v-card-title>
                    <v-icon class="me-2">mdi-text</v-icon>
                    <span>Reason</span>
                </v-card-title>
                <v-card-text class="text--text">
                    <div v-if="reasonItem && reasonItem.reason" style="white-space: pre-line;">{{reasonItem.reason}}</div>
                </v-card-text>
                <v-btn absolute top right icon color="muted" @click="reasonDialog = false;">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card>
        </v-dialog>

        <!-- Cancel Confirmation Dialog -->
        <v-dialog v-model="cancelDialog" max-width="350">
            <v-card>
                <v-card-title>Cancel Reschedule Request</v-card-title>
                <v-card-text>
                    Are you sure you want to cancel this reschedule request? This action cannot be undone.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="cancelling" @click="cancelDialog = false">Close</v-btn>
                    <v-btn :loading="cancelling" :disabled="cancelling" text color="red" @click="cancelRequest()">Cancel Request</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Edit Dialog -->
        <v-dialog v-model="editDialog" max-width="400">
            <v-card>
                <v-card-title>
                    <v-icon color="indigo" class="me-2">mdi-pencil</v-icon>
                    Edit Reschedule Request
                </v-card-title>
                <v-card-text>
                    <v-menu ref="editMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field hide-details placeholder="New Day" v-model="editForm.date" label="Day" prepend-inner-icon="mdi-calendar" class="mb-5" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="editForm.date" :min="today" @change="saveEditMenu" color="primary"></v-date-picker>
                    </v-menu>
                    <time-input v-model="editForm.start_time" :outlined="false" label="New Start Time" placeholder="Start Time" class="mb-5" />
                    <v-checkbox v-model="editForm.permanent" label="Permanent Reschedule" hide-details class="mb-5" />
                    <v-textarea v-model="editForm.reason" label="Reason" placeholder="Why do you want to reschedule?" outlined rows="3" hide-details />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" :disabled="updating" @click="editDialog = false">Cancel</v-btn>
                    <v-btn text color="indigo" :disabled="updating || !editForm.date || !editForm.start_time || !editForm.reason" :loading="updating" @click="updateRequest()">Save Changes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import TimeInput from '@/components/custom/time-input'

export default {
    props: {
        requests: Array
    },
    components: {
        TimeInput
    },
    data(){
        let d = new Date();
        return {
            today: d.toISOString().substr(0, 10),

            cancelling: false,
            cancelRequestId: null,
            cancelDialog: false,

            updating: false,
            editDialog: false,
            editRequestId: null,
            editForm: {
                date: '',
                start_time: '',
                permanent: false,
                reason: '',
            },

            reasonDialog: false,
            reasonItem: null,
        }
    },
    computed: {
        ...GlobalComputed,

    },
    methods: {
        ...GlobalMethods,

        otherPartyName(request){
            const myId = this.user && this.user.id;
            if (request.sender && request.sender.id !== myId) return request.sender.name;
            if (request.receiver && request.receiver.id !== myId) return request.receiver.name;
            return '';
        },
        isOriginalSender(request){
            const myId = this.user && this.user.id;
            const senderId = request.sender_id || (request.sender && request.sender.id);
            return myId === senderId;
        },
        openReasonDialog(request){
            this.reasonItem = request;
            this.reasonDialog = true;
        },
        showCancelDialog(request){
            this.cancelRequestId = request.id;
            this.cancelDialog = true;
        },
        showEditDialog(request){
            this.editRequestId = request.id;
            const startDate = new Date(request.start);
            this.editForm.date = startDate.toISOString().substr(0, 10);
            const hours = String(startDate.getHours()).padStart(2, '0');
            const minutes = String(startDate.getMinutes()).padStart(2, '0');
            this.editForm.start_time = `${hours}:${minutes}`;
            this.editForm.permanent = request.permanent;
            this.editForm.reason = request.reason || '';
            this.editDialog = true;
        },
        saveEditMenu(date){
            this.$refs.editMenu.save(date);
        },
        cancelRequest(){
            if (!this.cancelling){
                this.cancelling = true;
                return this.$store.dispatch('cancelMyRescheduleRequest', {id: this.cancelRequestId}).then(response=>{
                    this.cancelling = false;
                    this.cancelDialog = false;
                    this.showMsg('Reschedule request cancelled successfully', 'success');
                    this.$emit('load');
                }).catch(error=>{
                    this.cancelling = false;
                    this.showMsg('Error occurred during performing your action', 'error');
                })
            }
        },
        updateRequest(){
            if (!this.updating){
                this.updating = true;
                return this.$store.dispatch('updateMyRescheduleRequest', {
                    id: this.editRequestId,
                    date: this.editForm.date,
                    time: this.editForm.start_time,
                    permanent: this.editForm.permanent,
                    reason: this.editForm.reason,
                }).then(response=>{
                    this.updating = false;
                    this.editDialog = false;
                    this.showMsg('Reschedule request updated successfully', 'success');
                    this.$emit('load');
                }).catch(error=>{
                    this.updating = false;
                    const msg = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Error occurred during performing your action';
                    this.showMsg(msg, 'error');
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
